<template>
	<md-toolbar md-elevation="0" class="md-transparent">
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start" style="justify-content:space-between">
				<h3 class="md-title">{{$store.state.authentication.profile_name}}</h3>
			</div>
			<div class="md-toolbar-section-end">

				<md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>

				<div class="md-collapse">

					<md-list>
						<md-list-item to="#" class="dropdown">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown"><i class="material-icons">language</i></a>
								
								<ul class="dropdown-menu dropdown-menu-right">
									<li><a @click="language(1)">ភាសាខ្មែរ</a></li>
									<li><a @click="language(0)">English</a></li>
								</ul>
							</drop-down>
						</md-list-item>

						<md-list-item to="#" class="dropdown">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown">
									<i class="material-icons">person</i>
								</a>
								<ul class="dropdown-menu dropdown-menu-right">
									<li><a :href="config.redirect_url + '/profile/' + $store.state.authentication.profile_hash" _target="blank">{{translate(locale.viewThisProfile)}}</a></li>
									<li><a @click="logout()">{{translate(locale.logout)}}</a></li>
								</ul>
							</drop-down>
						</md-list-item>
					</md-list>
				</div>
			</div>
		</div>

	</md-toolbar>
</template>

<script>
	export default {
		data() {
			return {
				printer: false,
				interval: null
			}
		},
		created() {
			// this.getPrinter();
		},
		beforeDestroy() {
			// clearInterval(this.interval);
		},
		methods: {
			// getPrinter() {
			// 	var self = this;
			// 	this.interval = setInterval(() => {

			// 		this.$http.get("https://localhost:8084/test").then(data => {
			// 			self.printer = true;
			// 		})
			// 	}, 5000)
			// },
			toggleSidebar() {
				this.$sidebar.showSidebar = !this.$sidebar.showSidebar
			},
			logout() {
				this.$store.state.authentication.loggedIn = false;
				this.$store.state.authentication.authToken = null;
			},
			language(code) {
				this.$store.state.l.lang = code;
				this.$cookie.set('lang', code, 10);
				window.document.title = this.translate(this.locale.headTitle);
				// window.location.reload();
				// alert(1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue